import React from 'react';
import './FormField.scss';

interface FormFieldProps {
  label: React.ReactNode;
  children: React.ReactNode;
}

const FormField = (props: FormFieldProps): JSX.Element => {
  const { label, children } = props;
  return (
    <div className="field-wrap">
      <div>{label}</div>
      {children}
    </div>
  );
};

export default FormField;
